<template>
    <section class="program">
        <div class="program__selectors-wrapper">
            <div class="day-selector">
                <button
                    v-for="(day, index) in parsedContent.days"
                    :class="{ selected: index === selectedDay }"
                    @click="changeDay(index)"
                >
                    {{ day.dayName.value }}
                </button>
            </div>
            <template v-if="parsedContent.days[selectedDay].rooms.length > 1">
                <div
                    :style="{ 'border-top-color': color }"
                    class="short-line"
                ></div>
                <div class="day-selector">
                    <button
                        v-for="(room, index) in parsedContent.days[selectedDay]
                            .rooms"
                        :class="{ selected: index === selectedRoom }"
                        @click="selectedRoom = index"
                    >
                        {{ room.room.value }}
                    </button>
                </div>
            </template>
        </div>
        <div class="program__program-container">
            <h3 :style="{ color }" class="program__header">
                <span>
                    {{ parsedContent.days[selectedDay].dayName.value }},
                    {{ parsedContent.days[selectedDay].date.value }}
                </span>
                <span v-if="hasRoomName">{{
                        parsedContent.days[selectedDay].rooms[selectedRoom].room
                            .value
                    }}</span>
            </h3>
            <table class="program__table">
                <colgroup>
                    <col style="width: 130px"/>
                    <col style="width: calc(100% - 130px)"/>
                </colgroup>
                <template
                    v-for="session in parsedContent.days[selectedDay].rooms[
                        selectedRoom
                    ].sessions"
                >
                    <program-session :color="color" :session="session">
                    </program-session>
                    <program-lecture
                        v-for="lecture in session.lectures"
                        :lecture="lecture"
                    ></program-lecture>
                </template>
            </table>
        </div>
    </section>
</template>

<script>
import ProgramSession from "./programSession.vue";
import ProgramLecture from "./programLecture.vue";

export default {
    props: {
        json: {
            type: String,
        },
    },

    data() {
        return {
            selectedDay: 0,
            selectedRoom: 0,
            color: "#003dd9",
        };
    },
    computed: {
        parsedContent() {
            return JSON.parse(this.json);
        },
        hasRoomName() {
            if (
                Object.hasOwn(
                    this.parsedContent.days[this.selectedDay].rooms[
                        this.selectedRoom
                        ].room,
                    "settings"
                )
            ) {
                if (
                    Object.hasOwn(
                        this.parsedContent.days[this.selectedDay].rooms[
                            this.selectedRoom
                            ].room.settings,
                        "invisibleTitle"
                    )
                ) {
                    return !this.parsedContent.days[this.selectedDay].rooms[
                        this.selectedRoom
                        ].room.settings.invisibleTitle;
                }
                return true;
            }
            return true;
        },
    },
    components: {
        ProgramSession,
        ProgramLecture,
    },
    methods: {
        changeDay(index) {
            if (
                this.parsedContent.days[index].rooms.length <= this.selectedRoom
            ) {
                this.selectedRoom = 0;
            }
            this.selectedDay = index;
        },
    },
    created: function () {
        if (Object.hasOwn(this.parsedContent, "settings")) {
            if (Object.hasOwn(this.parsedContent.settings, "color")) {
                this.color = this.parsedContent.settings.color;
            }
        }
    },
};
</script>
<style lang="scss">
@use "../../scss/utilities/variables" as vars;
@use "sass:color";

.program {
    display: flex;
    flex-direction: column;
    gap: 5rem;

    &__table {
        width: 100%;
        table-layout: fixed;
        height: 1px;
        border-collapse: collapse;
    }

    .day-selector {
        display: flex;
        flex-direction: row;
        justify-content: center;
        gap: 1rem;
        flex-wrap: wrap;

        @media (max-width: 380px) {
            gap: 0.5rem;
        }

        button {
            border: none;
            border-radius: 25px;
            color: #111;
            font-weight: 500;
            background-color: #e5e5e5;

            padding: 0.5rem 1rem;
            min-width: min(125px, 18.75%);
            flex: 1 1 auto;
            max-width: fit-content;
            cursor: pointer;

            &:focus {
                outline: none;
            }

            &.selected {
                color: white;
                //background-color: vars.$blue;
            }
        }
    }

    .short-line {
        border-top-style: solid;
        border-top-width: 1px;
        width: 35px;
        margin: 0 auto;
    }

    &__selectors-wrapper {
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }

    &__program-container {
        h3 {
            font-size: 1.125rem;
        }
    }

    &__header {
        display: flex;
        flex-direction: column;
        gap: 0.25rem;
    }
}
</style>
